module.exports = __webpack_public_path__ + "static/media/anime3.bd6820f1.png";